








































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        SimpleSlider: () => import("../estates/simple-slider.vue")
    }
})
export default class EstateCard extends Vue {
    @Prop({ required: true }) estate!: Estate;
    @Prop({ required: false }) carousel!: boolean;

    viewingImage: number = 0;

    get image() {
        if (!this.estate.images || !this.estate.images[this.viewingImage]) {
            return "";
        }
        return this.estate.images[this.viewingImage].url;
    }

    get estateUrl() {
        // @ts-ignore
        console.log(this.$root.possibleLangPrefix);

        // @ts-ignore
        let base = `${this.$root.possibleLangPrefix}/${this.estate.is_project ? "projecten" : "panden"}/${this.estate.slug}?`;

        if (this.estate.price.amount) {
            base += `&price=${this.estate.price.amount}`;
        }

        if (this.estate.type) {
            base += `&type=${this.estate.type}`;
        }

        if (this.estate.project_id) {
            base += `&nieuwbouw=true`;
        }

        return base;
    }
}
